import { toast } from "react-toastify";


const success = (text) => toast.success(text) 
const warning = (text) => toast.warning(text) 
const error = (text) => toast.error(text) 
const dark = (text) => toast.dark(text) 

export {
    success,
    warning,
    error,
    dark
}